export const MAX_MESSAGE_REACTIONS = 20;
export const MAX_MESSAGE_USER_REACTIONS = 10;
